import {
  Input,
  OnInit,
  Directive,
  ViewContainerRef,
  TemplateRef,
  OnDestroy,
} from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AppConstants } from "../constants/constants";
import { UserProfileService } from "../_services/userprofile.service";

@Directive({
  selector: "[ifRoles]",
})
export class IfRolesDirective implements OnInit, OnDestroy {
  private subscription: Subscription[] = [];

  @Input() public ifRoles: Array<number>;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private userProfileService: UserProfileService,
    private route: Router
  ) {}

  public ngOnInit(): void {
    this.subscription.push(
      this.userProfileService.getOwnUserProfile$().subscribe((result) => {
        var roleId = result[AppConstants.ROLE_ID];

        if (!roleId) {
          this.viewContainerRef.clear();
        }

        if (this.findRoleIndex(roleId) < 0) {
          this.viewContainerRef.clear();
        } else {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
      })
    );
  }

  findRoleIndex(userRole): number {
    return this.ifRoles.indexOf(userRole);
  }

  public ngOnDestroy(): void {
    this.subscription.forEach((subscription: Subscription) =>
      subscription.unsubscribe()
    );
  }
}
